import { Outlet } from 'react-router-dom';
import Header from './Header';
import NavPanel from './NavPanel';

const Layout = () => {
  return (
    <div className="min-h-screen bg-[#fafafa]">
      <Header />
      <NavPanel />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
